import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { TopBar } from './components/sections/TopBar';
import { Hero } from './components/sections/Hero';
import { ProblemAgitation } from './components/sections/ProblemAgitation';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3udazyhcy738x">
      <div className="w-full min-h-full bg-bg-primary font-body text-ink" data-id="element-1" data-mp="3ucjcxuxf2du9">
        <TopBar data-id="element-2" data-mp="d3mi75km8lhi" />
        <main data-id="element-3" data-mp="d45vg8zbmlp7">
          <Hero data-id="element-4" data-mp="d2l7x3bfc30u" />
          <ProblemAgitation data-id="element-5" data-mp="85l1usekr09q" />
          <Suspense fallback={null} data-id="element-6" data-mp="85bd1859mz5m">
            <TrustStats data-id="element-7" data-mp="86cm572q1bkp" />
            <Transformation data-id="element-8" data-mp="3gle7gc7darc0" />
            <Method data-id="element-9" data-mp="3gklag2y7ng72" />
            <ForYou data-id="element-10" data-mp="3gm66jx06b771" />
            <WhatYouGet data-id="element-11" data-mp="3glo2ie79rook" />
            <BonusesDetail data-id="element-12" data-mp="3bmbfntgeehlz" />
            <InstantAccess data-id="element-13" data-mp="3bn2z65wq0ovw" />
            <Testimonials data-id="element-14" data-mp="3bnuwpm9vowot" />
            <FAQ data-id="element-15" data-mp="3bkgss9lkgff9" />
            <FinalCTA data-id="element-16" data-mp="3qaxt1pmgszak" />
            <Pricing data-id="element-17" data-mp="3qbg07hao0xx9" />
            <Guarantee data-id="element-18" data-mp="3qcr0h74wjnjm" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="3ljxwilh9cj8l">
          <Footer data-id="element-20" data-mp="3liwjibgolmo8" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="3limuor7dhlk4" />
      </div>
    </LazyMotion>;
}